( function( $ ) {
  $( '.__time' ).attr( 'type', 'time' );

  $( window ).load( function() {
    /* Preloader */
    $( '.__preloader' ).fadeOut();
    $( 'body' ).removeClass( '__loading' );
  } );
} ) ( jQuery );